<template>
  <div>
    <div class="loading_bg_wrap"></div>
    <div class="loading_wrap">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <p class="text">{{text}}...</p>
    </div>
  </div>
</template>
<script type="text/babel">
  export default{
    props:{
      text:{
        type:String,
        default:"Loading...."
      },
    }
  }
</script>
<style lang="less">
  .loading_wrap{
    width: 600px;
    height: 30px;
    position: fixed;
    top: 50%;
    left: 50%;
    text-align: center;
    transform: translate(-50%,-50%);
    -webkit-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    z-index: 999;
  .text{
    color: #1fc8db;
    font-size: 20px;
    margin-top: 60px;
  }
  }
  .loading_wrap span{
    display: inline-block;
    width: 30px;
    height: 100%;
    margin-right: 30px;
    background: #1fc8db;
    -webkit-transform-origin: right bottom;
    -webkit-animation: load 1s ease infinite;
  }
  .loading_wrap span:last-child{
    margin-right: 0px;
  }
  @-webkit-keyframes load{
    0%{
      opacity: 1;
    }
    100%{
      opacity: 0;
      -webkit-transform: rotate(90deg);
    }
  }
  .loading_wrap span:nth-child(1){
    -webkit-animation-delay:0.13s;
  }
  .loading_wrap span:nth-child(2){
    -webkit-animation-delay:0.26s;
  }
  .loading_wrap span:nth-child(3){
    -webkit-animation-delay:0.39s;
  }
  .loading_wrap span:nth-child(4){
    -webkit-animation-delay:0.52s;
  }
  .loading_wrap span:nth-child(5){
    -webkit-animation-delay:0.65s;
  }

  .loading_bg_wrap{
    background: rgba(255,255,255,0.7);
    width: 100%;
    height: 100%;
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
  }
</style>
